import React, { useCallback, useState } from 'react';
import { Stack, Tab, Tooltip, Typography } from '@mui/material';
import { HeadlessPageWrapper } from 'templates/PageWrapper/PageWrapper';
import { StyledPaper } from 'pages/ContactsPage/Contacts.styles';
import { StyledTabList } from 'molecules/Card/Card.styles';
import { StyledTabPanel } from 'organisms/CompanyInvoicesTabs/CompanyInvoicesTabs.styles';
import { TabContext, TabPanel } from '@mui/lab';
import CloudOpsReportPage from 'organisms/CloudOpsReportAdmin/CloudOpsReportAdmin';
import SalesReportPage from 'organisms/SalesReport/SalesReport';
import { useBaoSelector } from 'utils/hooks/redux';
import { GOOGLE_SALES_REP, SALES_REP } from 'utils/constants/roles';
import ExpenseReport from 'organisms/ExpenseReport';
import PipelinesReport from 'organisms/SalesReport/PipelinesReport';
import { NewBadge } from 'molecules/NewBadge';
import { HelpOutlineOutlined } from '@mui/icons-material';
import SecurityReport, {
  spaDescriptionText,
} from 'organisms/CloudOpsReport/tabs/SecurityReport';

type TabType =
  | 'salesRep'
  | 'autoInvoicing'
  | 'googlers'
  | 'expensesRep'
  | 'pipelines'
  | 'securityReports';

const ReportsPage = () => {
  const [selectedTab, setSelectedTab] = useState<TabType>('autoInvoicing');

  const { value: user } = useBaoSelector((state) => state.user);

  const handleChangeTabs = useCallback(
    (event: React.SyntheticEvent, newValue: TabType) => {
      setSelectedTab(newValue);
    },
    []
  );

  function a11yProps(index: number) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  if (user?.userType === SALES_REP) {
    return (
      <HeadlessPageWrapper>
        <StyledPaper>
          <SalesReportPage />
        </StyledPaper>
      </HeadlessPageWrapper>
    );
  }

  if (user?.userType === GOOGLE_SALES_REP) {
    return (
      <HeadlessPageWrapper>
        <StyledPaper>
          <PipelinesReport />
        </StyledPaper>
      </HeadlessPageWrapper>
    );
  }

  return (
    <HeadlessPageWrapper>
      <StyledPaper sx={{ minWidth: '1150px !important' }}>
        <TabContext value={selectedTab}>
          <StyledTabList
            onChange={handleChangeTabs}
            aria-label="Projects-invoicing and Sales Reports tabs"
            variant="fullWidth"
            sx={{
              '.Mui-selected': {
                fontSize: '1rem !important',
              },
            }}
          >
            <Tab
              label="Projects-invoicing"
              {...a11yProps(1)}
              className={selectedTab === 'autoInvoicing' ? '.active' : ''}
              value="autoInvoicing"
            />
            <Tab
              label="Sales Rep"
              {...a11yProps(0)}
              className={selectedTab === 'salesRep' ? '.active' : ''}
              value="salesRep"
            />
            <Tab
              label="Googlers"
              {...a11yProps(0)}
              className={selectedTab === 'googlers' ? '.active' : ''}
              value="googlers"
            />
            <Tab
              label={
                <NewBadge offsetX={-6}>
                  <Tooltip
                    title={
                      <Stack>
                        <Typography
                          variant="body2"
                          fontSize="12px"
                          sx={{ fontWeight: 'bold', color: '#FFFFFF' }}
                        >
                          See Where Your Business Is at Risk!
                        </Typography>
                        {spaDescriptionText}
                      </Stack>
                    }
                  >
                    <HelpOutlineOutlined
                      sx={{ width: 16, height: 16, mr: 1 }}
                    />
                  </Tooltip>
                  SPA
                </NewBadge>
                // Security Reports
              }
              {...a11yProps(0)}
              className={selectedTab === 'securityReports' ? '.active' : ''}
              value="securityReports"
            />
            {/* <Tab
              label={
                <NewBadge offsetX={-6}>
                  <Tooltip title={observabilityDescriptionText}>
                    <HelpOutlineOutlined
                      sx={{ width: 16, height: 16, mr: 1 }}
                    />
                  </Tooltip>
                  Observability
                </NewBadge>
              }
              {...a11yProps(0)}
              className={selectedTab === 'observability' ? '.active' : ''}
              value="observability"
            /> */}
            {/* {user?.userType === SUPER_ADMIN && (
              <Tab
                label="Pipelines"
                {...a11yProps(0)}
                className={selectedTab === 'pipelines' ? '.active' : ''}
                value="pipelines"
              />
            )} */}
            <Tab
              label="Expense Invoicing"
              {...a11yProps(0)}
              className={selectedTab === 'expensesRep' ? '.active' : ''}
              value="expensesRep"
            />
          </StyledTabList>
          <StyledTabPanel value="autoInvoicing" sx={{ p: 0 }}>
            <CloudOpsReportPage />
          </StyledTabPanel>
          <TabPanel value="salesRep" sx={{ p: 0 }}>
            <SalesReportPage />
          </TabPanel>
          <TabPanel value="googlers" sx={{ p: 0 }}>
            <PipelinesReport />
            {/* <GoogleSalesReport /> */}
          </TabPanel>
          {/* <TabPanel value="pipelines" sx={{ p: 0 }}>
            <PipelinesReport />
          </TabPanel> */}
          <TabPanel value="expensesRep" sx={{ p: 0 }}>
            <ExpenseReport />
          </TabPanel>
          <TabPanel value="securityReports" sx={{ p: 0 }}>
            <SecurityReport />
          </TabPanel>
          {/* <TabPanel value="observability" sx={{ p: 0 }}>
            <ObervabilityReport />
          </TabPanel> */}
        </TabContext>
      </StyledPaper>
    </HeadlessPageWrapper>
  );
};

export default ReportsPage;
